import { mapMutations, mapActions } from 'vuex';
import _ from 'lodash';

export default ({
  methods: {
    ...mapMutations('record/station', {
      addStationChange: 'addChange',
    }),
    ...mapMutations('record/viewer', {
      addBroadcastChange: 'addChange',
    }),
    ...mapActions('record/station', {
      addStationSourceChange: 'addSourceChange',
    }),
    ...mapActions('record/viewer', {
      addBroadcastSourceChange: 'addSourceChange',
    }),

    ..._({
      stationValueChanged: 'addStationChange',
      stationSourceChanged: 'addStationSourceChange',
      broadcastValueChanged: 'addBroadcastChange',
      broadcastSourceChanged: 'addBroadcastSourceChange',
    })
      // eslint-disable-next-line func-names
      .mapValues(handler => function ({ id, ...changes } = {}) {
        if (id) {
          this[handler]({ name: id, ...changes });
          return true;
        }
        return false;
      })
      .value(),
  },
});
